(function(exports){
'use strict';

let $locale = null;

const $dict = {
	fr: {
		n_available_places: '%s dispo(s)',
		at_price: ' à ce tarif',
		availabilities: {
			label: 'disponibilités',
			date: 'Disponibilités pour : ',
			price: ' place(s) disponible(s) à ',
			discount: 'au lieu de',
		},
		book_now: 'Réservez maintenant',
		months: {
			1: 'janv.',
			2: 'févr.',
			3: 'mars',
			4: 'avr.',
			5: 'mai',
			6: 'juin',
			7: 'juill.',
			8: 'août',
			9: 'sept.',
			10: 'oct.',
			11: 'nov.',
			12: 'déc.',
		},
		days: {
			1: 'Dim',
			2: 'Lun',
			3: 'Mar',
			4: 'Mer',
			5: 'Jeu',
			6: 'Ven',
			7: 'Sam',
		},
	},

	en: {
		n_available_places: '%s available',
		at_price: ' at this price',
		availabilities: {
			label: 'available',
			date: 'Availabilities for: ',
			price: ' available places at ',
			discount: 'instead of',
		},
		book_now: 'Book now',
		months: {
			1: 'Jan.',
			2: 'Feb.',
			3: 'Mar.',
			4: 'Apr.',
			5: 'May',
			6: 'Jun.',
			7: 'Jul.',
			8: 'Aug.',
			9: 'Sep.',
			10: 'Oct.',
			11: 'Nov.',
			12: 'Dec.',
		},
		days: {
			1: 'Sun',
			2: 'Mon',
			3: 'Tue',
			4: 'Wed',
			5: 'Thu',
			6: 'Fri',
			7: 'Sat',
		},
	},
}

const Translate = (key, maybe_arg) => {
	const str = $dig($dict, `${$locale}.${key}`);

	return str ? str.replace('%s', (maybe_arg || '').toString()) : `translation missing: ${key}`;
}

const Init = locale => $locale = locale;

exports.$i18n = {
	_t: Translate,
	Init,
};
}(window));
